<template>
  <group-element
    :id="element.id"
    :toggle="toggle"
    :size="size"
    v-bind="$attrs"
  >
    <template #default="{ select, group, parent }">
      <!-- The template that can be manipulated -->
      <element-renderer
        v-for="elementId in childElementsReversed"
        v-show="!getElementById(elementId)?.layerHiddenInGraphics"
        :id="elementId"
        :key="elementId"
        ref="children"
        :group="group"
        :type="getElementValueByProp(elementId, 'type')"
        :parent="parent"
        class="group-item"
        :toggle="toggle"
        @select="select"
      />

      <!-- the repeated elements -->
      <template v-for="elements in virtualElementsReversed">
        <element-renderer
          v-for="e in elements"
          v-show="!getElementById(e)?.layerHiddenInGraphics"
          :id="e"
          :key="e"
          ref="children"
          :group="group"
          :type="getElementValueByProp(e, 'type')"
          :parent="parent"
          :toggle="toggle"
        />
      </template>
    </template>
  </group-element>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import elementsMixins from '../../mixins/elements-mixins';
import DataRepeaterMixins from '../../mixins/data-repeater-mixins';

import GroupElement from './Group.vue';

export default {
  name: 'DataList',
  inheritAttrs: false,
  components: {
    GroupElement,
    ElementRenderer: defineAsyncComponent(() => import('./ElementRenderer')),
  },
  mixins: [elementsMixins, DataRepeaterMixins],

  computed: {
    size() {
      const { layout, gap } = this.settings;
      let { width, height } = this.element.styles;

      if (layout === 'row') {
        width += (width + gap) * (this.filteredData.length - 1);
      } else {
        height += (height + gap) * (this.filteredData.length - 1);
      }

      return { width, height };
    },

    // Editable elements in the list
    // Also mapped to the first dataset in the range
    childElements() {
      return this.getElementGroupMap[this.id] || [];
    },

    childElementsReversed() {
      return [...this.childElements]
        .reverse();
    },
  },
};
</script>
